// extracted by mini-css-extract-plugin
export default {"container":"SortComponent_container__cWNVH","status":"SortComponent_status__CJ5Xi"};